import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const TREND_CONFIG = {
  improving: { color: 'var(--vo-success)', bg: 'var(--vo-success-10)', border: 'var(--vo-success-20)', iconFill: 'white', circleBg: 'var(--vo-success)' },
  stable:    { color: 'var(--vo-celeste)', bg: 'var(--vo-capri-50)', border: 'color-mix(in srgb, var(--vo-info) 20%, transparent)', iconFill: 'white', circleBg: 'var(--vo-celeste)' },
  declining: { color: 'var(--vo-warning)', bg: 'var(--vo-heatmap-risky)', border: 'color-mix(in srgb, var(--vo-warning) 20%, transparent)',  iconFill: 'white', circleBg: 'var(--vo-warning)' },
}

const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: ${({ $bg }) => $bg};
  border: 1px solid ${({ $border }) => $border};
  border-radius: 12px;
  margin-bottom: 32px;
`

const Circle = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const TextGroup = styled.div``

const Label = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: ${({ $color }) => $color};
  margin: 0 0 2px;
`

const Desc = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: var(--vo-ink-2);
  margin: 0;
`

const TrendingUpSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
  </svg>
)

const TrendingFlatSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
    <path d="M22 12l-4-4v3H3v2h15v3z"/>
  </svg>
)

const TrendingDownSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
    <path d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"/>
  </svg>
)

export const TrendIndicator = ({ label, description, trend = 'stable' }) => {
  const { t } = useTranslation('transparency')
  const config = TREND_CONFIG[trend] || TREND_CONFIG.stable
  const Icon = trend === 'improving' ? TrendingUpSvg : trend === 'declining' ? TrendingDownSvg : TrendingFlatSvg

  return (
    <Pill $bg={config.bg} $border={config.border}>
      <Circle $bg={config.circleBg}>
        <Icon />
      </Circle>
      <TextGroup>
        <Label $color={config.color}>{label || t('public.defaultPostureLabel')}</Label>
        {description && <Desc>{description}</Desc>}
      </TextGroup>
    </Pill>
  )
}

TrendIndicator.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  trend: PropTypes.string,
}
